/* tslint:disable */
/* eslint-disable */
/**
 * Commerce Webservices
 * Manages all of the common commerce functionality, and also includes customizations from installed AddOns. The implementing extension is called commercewebservices.
 *
 * The version of the OpenAPI document: 2.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Attributes needed to update for guest user, such as email address 
 * @export
 * @interface SAPGuestUserRequest
 */
export interface SAPGuestUserRequest {
    /**
     * Email of the guest user. It will be used during the guest checkout process but may be optional when creating a guest user for a cart.
     * @type {string}
     * @memberof SAPGuestUserRequest
     */
    email?: string;
}

/**
 * Check if a given object implements the SAPGuestUserRequest interface.
 */
export function instanceOfSAPGuestUserRequest(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function SAPGuestUserRequestFromJSON(json: any): SAPGuestUserRequest {
    return SAPGuestUserRequestFromJSONTyped(json, false);
}

export function SAPGuestUserRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SAPGuestUserRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'email': !exists(json, 'email') ? undefined : json['email'],
    };
}

export function SAPGuestUserRequestToJSON(value?: SAPGuestUserRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'email': value.email,
    };
}

